<template>
  <v-container fluid class="mt-2 pa-0">
    <v-row>
      <v-col cols="12" md="12" v-if="showSelf">
        <el-switch
          label="Ieškoti pagal save"
          tooltip="Paieška. Fizinis. Pagal save"
          v-model="self"
        />
      </v-col>
      <v-col cols="12" md="12" class="mb-2">
        <el-switch
          :readonly="isSelf"
          label="LR Gyventojų registre neregistruotas asmuo"
          tooltip="Paieška. Fizinis. Neregistruotas"
          v-model="foreign"
        />
      </v-col>
      <v-col cols="12" v-if="showForeignKodoTipas">
        <span class="bold-label"
          >Kodo tipas<el-need /><el-tooltip
            inline
            tooltip="Paieška. Fizinis. Kodo tipas"
          />
        </span>
        <el-radio-group
          inline
          class="mt-0 mb-2"
          required
          :items="filteredForeignKodoTipas"
          v-model="mainData.asm_kodo_tipas"
        />
      </v-col>
      <v-col cols="12" md="4" v-if="showFizinisKodas">
        <el-text-field
          :readonly="isSelf"
          required
          label="Fizinio asmens kodas"
          tooltip="Paieška. Fizinis. Fizinio asmens kodas"
          key="kodas"
          v-model="mainData.asm_asmens_kodas"
          autofocus
        />
      </v-col>
      <v-col cols="12" md="4">
        <el-text-field
          :readonly="isSelf"
          :required="requiredVardas"
          label="Vardas"
          tooltip="Paieška. Fizinis. Vardas"
          key="vardas"
          v-model="mainData.asm_fiz_vardas"
        />
      </v-col>
      <v-col cols="12" md="4">
        <el-text-field
          :readonly="isSelf"
          :required="requiredPavarde"
          label="Pavardė"
          tooltip="Paieška. Fizinis. Pavardė"
          key="pavarde"
          v-model="mainData.asm_fiz_pavarde"
        />
      </v-col>
      <v-col cols="12" md="4" v-if="showForeignGimimoData">
        <el-date-picker
          :readonly="isSelf"
          :required="isForeign"
          label="Gimimo data"
          tooltip="Paieška. Fizinis. Gimimo data"
          v-model="mainData.asm_gimimo_data"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  name: 'PaieskaFizinis',
  mixins: [userRole],
  props: {
    mainData: Object,
  },
  $_veeValidate: {
    validator: '$validator',
  },
  data() {
    return {
      self: false,
      foreign: false,
    }
  },
  watch: {
    self(value) {
      this.mainData.self = value
      if (value) {
        if (!this.paieskaSelf) {
          this.foreign = false
          return
        }
        this.foreign = this.paieskaSelf.foreign
        this.mainData.asm_asmens_kodas = this.paieskaSelf.asm_kodas
        this.mainData.asm_fiz_vardas = this.paieskaSelf.vardas
        this.mainData.asm_fiz_pavarde = this.paieskaSelf.pavarde
      }
    },
    foreign(value) {
      this.mainData.foreign = value
      if (value && !this.mainData.asm_kodo_tipas) {
        this.mainData.asm_kodo_tipas = 'data'
      }
      if (!value) {
        this.mainData.asm_kodo_tipas = null
      }
    },
  },
  computed: {
    ...mapGetters(['paieskaSelf']),
    isForeign() {
      return (this.mainData && this.mainData.foreign) ?? false
    },
    isSelf() {
      return this.self
    },
    showSelf() {
      return this.role('EL_FA') && !this.role('EL_JA')
    },
    requiredVardas() {
      return !this.roleRGV || this.isForeign
    },
    requiredPavarde() {
      return !this.roleRGV || this.isForeign
    },
    foreignKodoTipas() {
      return [
        {
          label: this.$t('ILTU'),
          value: 'iltu',
        },
        {
          label: this.$t('Gimimo data'),
          value: 'data',
        },
      ]
    },
    filteredForeignKodoTipas() {
      return this.foreignKodoTipas.filter(item => {
        return !item.hide
      })
    },
    showForeignKodoTipas() {
      return this.isForeign && !this.isSelf
    },
    showForeignGimimoData() {
      return this.isForeign && this.mainData.asm_kodo_tipas === 'data'
    },
    showFizinisKodas() {
      if (!this.isForeign) {
        return true
      }
      return this.isForeign && this.mainData.asm_kodo_tipas !== 'data'
    },
  },
}
</script>
<style lang="scss" scoped></style>
